import './css/App.css'
import Header from './components/sectioning/Header'
import Footer from './components/sectioning/Footer'
import ScrollToTop from './components/utils/ScrollToTop'
import AnimatedRoutes from './components/utils/AnimatedRoutes'
import { BrowserRouter as Router} from 'react-router-dom'
import { AppProvider } from './context/AppContext'

function App() {
  
  return(
    <AppProvider>
      <Router>
        <ScrollToTop/>
        <Header/>
        <AnimatedRoutes/>
        <Footer/>
      </Router>
    </AppProvider>
  )
}

export default App;
